// extracted by mini-css-extract-plugin
export var aiStarIcon = "_ai-4";
export var closeButton = "_ai-6";
export var dismissButton = "_ai-3";
export var editImageWithAiContainer = "_ai-8";
export var imageUploadWrapper = "_ai-7";
export var misspelledWord = "_ai-5";
export var spellCheckContainer = "_ai-2";
export var spin = "_ai-1";
export var spinning = "_ai-0";